import { render, staticRenderFns } from "./histogramstudent.vue?vue&type=template&id=59911871&scoped=true"
import script from "./histogramstudent.vue?vue&type=script&lang=js"
export * from "./histogramstudent.vue?vue&type=script&lang=js"
import style0 from "./histogramstudent.vue?vue&type=style&index=0&id=59911871&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59911871",
  null
  
)

export default component.exports